import React from 'react';

const IconExternal = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-arrow-up-right">
    <path d="M5.5 18.5 18.5 5.5" />
    <path d="M9.5 5.5h9v9" />
  </svg>
);

export default IconExternal;
